export default __webpack_public_path__ + "static/media/mail.ddbb610b.svg";